export enum EnrollModuleClass {
    None = -1,
    Aflac = 'Aflac',
    AllState = 'AllState',
    AlsGroupAccident = 'AlsGroupAccident',
    AlsGroupMedical = 'AlsGroupMedical',
    AmericanFidelityLife = 'AmericanFidelityLife',
    KbaHospitalIndemnity = 'KbaHospitalIndemnity',
    TransamericaAccident = 'TransamericaAccident',
    TransamericaCancer = 'TransamericaCancer',
    TransamericaAccident17 = 'TransamericaAccident17',
    TransamericaAccident18 = 'TransamericaAccident18',
    TransamericaUniversalLifeElite10 = 'TransamericaUniversalLifeElite10',
    TransamericaDisability93 = 'TransamericaDisability93',
    TransamericaHospitalIndemnity15 = 'TransamericaHospitalIndemnity15',
    TransamericaTransSelectGi40 = 'TransamericaTransSelectGi40',
    TransamericaUniversalLifeGi21 = 'TransamericaUniversalLifeGi21'
}